import { render, staticRenderFns } from "./BeliefMapSurvey.vue?vue&type=template&id=62a5c968&scoped=true"
import script from "./BeliefMapSurvey.vue?vue&type=script&lang=js"
export * from "./BeliefMapSurvey.vue?vue&type=script&lang=js"
import style0 from "./BeliefMapSurvey.vue?vue&type=style&index=0&id=62a5c968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a5c968",
  null
  
)

export default component.exports